<template>
  <div class="lc_cont">
    <el-select
      style="width: 120px"
      class="spacing_right"
      popper-class="condition_popper_select"
      size="small"
      clearable
      value-key="id"
      v-model="groupItem"
      @change="changeGroupHandle"
    >
      <el-option v-for="lb1 of labelOptionList" :key="lb1.id" :label="lb1.label" :value="lb1">{{ lb1.label }}</el-option>
    </el-select>
    <el-select
      style="width: 120px"
      class="spacing_right"
      popper-class="condition_popper_select"
      size="small"
      clearable
      value-key="id"
      v-model="labelItem"
      @change="changeLabelHandle"
    >
      <el-option v-for="lb2 of groupItem.children || []" :key="lb2.id" :label="lb2.label" :value="lb2">{{ lb2.label }}</el-option>
    </el-select>
    <!-- 条件符选项 -->
    <el-select
      style="width: 120px"
      size="small"
      class="spacing_right"
      popper-class="condition_popper_select"
      v-model="rule.type"
      clearable
      @change="changeTypeHandle"
    >
      <el-option v-for="op of operatorList" :key="op.value" :label="op.label" :value="op.value">{{ op.label }}</el-option>
    </el-select>
    <!-- 值 -->
    <el-select
      style="width: 200px"
      popper-class="condition_popper_select"
      size="small"
      multiple
      collapse-tags
      clearable
      v-model="rule.params"
      v-if="rule.type !== '' && !isEQNull"
    >
      <el-option v-for="lb3 of labelItem.children || []" :key="lb3.id" :label="lb3.label" :value="lb3.id">{{
        lb3.label
      }}</el-option>
    </el-select>
  </div>
</template>

<script>
// import { getSampleOptions } from '@/api/common';
import { labelRulers } from './config'
import { COMMON } from './constants'

export default {
  name: 'LabelCondition',
  props: {
    isOptionsLoad: {
      type: Boolean,
      default: false
    },
    rule: {
      type: Object,
      default: () => ({})
    }
  },
  inject: {
    conditionInject: {
      default: () => ({
        labelOptions: [],
        isFlushing: false
      })
    }
  },
  data() {
    return {
      operatorList: labelRulers,
      labelList: [],
      groupItem: {},
      labelItem: {},
      parent: {
        group: '',
        label: ''
      },
      unWatch: null
    }
  },
  computed: {
    labelOptionList() {
      return this.isOptionsLoad ? this.labelList : this.conditionInject.labelOptions
    },
    isEQNull() {
      return Object.values(COMMON).includes(this.rule.type)
    }
  },
  watch: {
    'conditionInject.isFlushing': {
      handler() {
        this.setParentItem()
      }
    }
  },
  mounted() {
    if (this.isOptionsLoad) {
      this.getLabelList()
    }
    this.rule.attributeId = -1
    this.unWatch = this.$watch(
      () => this.labelOptionList.length,
      size => {
        if (size > 0) {
          this.setParentItem()
          this.cancelWatch()
        }
      }
    )
  },
  beforeDestroy() {
    this.rule.attributeId = -1
    this.rule.cascadeIdx = 0
    this.rule.type = ''
    this.rule.fieldName = ''
    this.rule.params = null
    this.cancelWatch()
  },
  methods: {
    cancelWatch() {
      if (this.unWatch !== null) {
        this.unWatch()
        this.unWatch = null
      }
    },
    getLabelList() {
      // getSampleOptions('2').then((res) => {
      //   const list = res?.data?.data || [];
      //   this.labelList = list;
      // }).catch(() => {
      //   this.$message.error('获取标签属性失败');
      // });
    },
    setParentItem() {
      if (this.rule.fieldName.startsWith('tag:')) {
        const [groupId, labelId] = this.rule.fieldName.replace('tag:', '').split('&')
        this.parent.group = groupId ?? ''
        this.parent.label = labelId ?? ''
        this.groupItem = this.labelOptionList.find(f => `${f.id}` === `${groupId}`) || {}
        if (Array.isArray(this.groupItem.children)) {
          this.labelItem = this.groupItem.children.find(f => `${f.id}` === `${labelId}`) || {}
        }
      }
    },
    setFieldName() {
      this.rule.fieldName = `tag:${this.parent.group}&${this.parent.label}`
    },
    changeTypeHandle() {
      if (this.isEQNull || this.rule.type === '') {
        this.rule.params = null
      }
    },
    changeGroupHandle() {
      this.parent.group = this.groupItem.id
      this.labelItem = {}
      this.rule.params = null
      this.setFieldName()
    },
    changeLabelHandle() {
      this.parent.label = this.labelItem.id
      this.rule.params = null
      this.setFieldName()
    }
  }
}
</script>

<style lang="scss" scoped>
.lc_cont {
  display: flex;
  align-items: center;
  .spacing_right {
    margin-right: 8px;
  }
}
</style>
